import { classnames } from '@aibees/shared/utils';
import { Switch, SwitchProps, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import * as Styled from './styles';
import * as SX from './sx';
import type { InformationItemProps as Props } from './types';

export const InformationItem = memo(({ className, item, isSwitch }: Props) => {
  const { title, value } = item;
  const [checked, setChecked] = useState(false);
  const { markDirty } = useChangeTracker();

  const handleChangeSwitch: SwitchProps['onChange'] = (e) => {
    setChecked(e.target.checked);
    markDirty();
  };

  return (
    <Styled.Wrapper
      className={classnames('InformationItem', className)}
      sx={SX.root}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography variant="body3" fontWeight={400} color="grey.500">
        {title}
      </Typography>
      {isSwitch ? (
        <Switch checked={checked} onChange={handleChangeSwitch} size="small" />
      ) : (
        <Typography variant="body3" fontWeight={500} color="grey.700">
          {value}
        </Typography>
      )}
    </Styled.Wrapper>
  );
});

InformationItem.displayName = 'InformationItem';
